import React, { SVGAttributes } from "react";

const Transfer: React.FC<SVGAttributes<any>> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M3.39111 12.5881H20.0791" stroke="currentColor" stroke-opacity="0.8" stroke-width="2.26957" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.73132 23.2683H11.4014" stroke="currentColor" stroke-opacity="0.8" stroke-width="2.26957" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M14.739 23.2683H20.0791" stroke="currentColor" stroke-opacity="0.8" stroke-width="2.26957" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M30.0919 19.9709V22.7477C30.0919 27.4337 28.9038 28.6086 24.1644 28.6086H9.31874C4.57936 28.6086 3.39117 27.4337 3.39117 22.7477V11.7737C3.39117 7.08774 4.57936 5.9129 9.31874 5.9129H20.0792"
        stroke="currentColor"
        stroke-opacity="0.8"
        stroke-width="2.26957"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M27.4218 5.91284V13.9231L30.0919 11.253" stroke="#FFBE40" stroke-width="2.26957" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M27.4218 13.9232L24.7517 11.2531" stroke="#FFBE40" stroke-width="2.26957" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default Transfer;
